import { Badge, Stack, Typography, Pagination } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import QuickreplyIcon from "@mui/icons-material/Quickreply";
import ForumIcon from "@mui/icons-material/Forum";
import PermPhoneMsgIcon from "@mui/icons-material/PermPhoneMsg";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import OutboundIcon from "@mui/icons-material/Outbound";
import { BaseUrl } from "../../container/BaseUrl/BaseUrl";
import { Modal } from "react-bootstrap";
import Tooltip from "@mui/material/Tooltip";
import { toast } from "react-toastify";
import { setsidebarVal } from "../../redux/actions/actions";
import { connect } from "react-redux";
import { IconButton } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const mapStateToProps = (state) => {
  return {};
};

const ViewAllAgentDialogBox = () => {
  const AvcUrl = localStorage.getItem("AvcUrl");
  const navigate = useNavigate();
  const [sortOrder, setSortOrder] = useState("asc");
  const [teamactivitydashboardcount, setTeamactivitydashboardcount] = useState(
    []
  );
  const [OngoingInteractionList, setOngoingInteractionList] = useState([]);
  const [OngoingInteraction, setOngoingInteraction] = useState(false);
  const [Interactionpage, setInteractionpage] = useState(1);
  const [Interactionpagepagination, setInteractionpagePagination] = useState(0);
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];

  const sortStatus = () => {
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  // const sortedData = teamactivitydashboardcount.sort((a, b) => {
  //   const statusA = a.agent_id ? a.agent_id.agent_status_real : "";
  //   const statusB = b.agent_id ? b.agent_id.agent_status_real : "";
  //   if (sortOrder === "asc") {
  //     return statusA.localeCompare(statusB);
  //   } else {
  //     return statusB.localeCompare(statusA);
  //   }
  // });

  const sortedData = teamactivitydashboardcount.sort((a, b) => {
    const statusA = a.agent_id ? a.agent_id.agent_status_real : "";
    const statusB = b.agent_id ? b.agent_id.agent_status_real : "";
    const statusALast = statusA === "Is LoggedOut";
    const statusBLast = statusB === "Is LoggedOut";

    if (statusALast && !statusBLast) {
      return 1;
    } else if (!statusALast && statusBLast) {
      return -1;
    } else {
      if (sortOrder === "asc") {
        return statusA.localeCompare(statusB);
      } else {
        return statusB.localeCompare(statusA);
      }
    }
  });

  const SupervisorObserver = async (el) => {
    localStorage.removeItem("client");
    try {
      const access_token = localStorage.getItem("access_token");
      let old_agent_id = JSON.parse(localStorage.getItem("tokenAgent"));

      if (
        el.channel == "webchat" ||
        el.channel == "from_whatsapp" ||
        el.channel == "from_facebook" ||
        el.channel == "from_purple"
      ) {
        let dataToPass = {
          sessionId: el.chat_session_id,
          agentId: old_agent_id.agent_id,
          oldAgentId: el.agent,
        };

        const data = await axios.post(
          BaseUrl + "/users/conferenceAgent",
          dataToPass,
          {
            headers: {
              Authorization: "Bearer " + access_token,
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        );

        if (data.data.status == "OK") {
          navigate("/main/Chat");
          props.setsidebarVal("Chat");
          localStorage.setItem("indexOf", 2);
          toast.success("Conferenced to supervisor success", {
            position: "top-right",
            autoClose: 500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.warn(data.data.message, {
            position: "top-right",
            autoClose: 500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
        }
      } else if (el.channel == "voice") {
        try {
          let ssToken = localStorage.getItem("ssoToken");
          await axios
            .post(
              AvcUrl +
                `/voice/terminal/${localStorage.getItem(
                  "agentLoginTerminalId"
                )}/observe/sip:${localStorage.getItem(
                  "agentLoginTerminalId"
                )}@avayaipo.sltavayainp.com/${el.voice_contactId}`,
              {},
              {
                headers: {
                  ssoToken: ssToken,
                },
              }
            )
            .then((res) => {
              if (res.data.statusCode == 200) {
                localStorage.setItem("showBarginButton", "true");
              } else {
                toast.warn(res.data.message, {
                  position: "top-right",
                  autoClose: 500,
                  hideProgressBar: true,
                  closeOnClick: false,
                  pauseOnHover: false,
                  draggable: false,
                  progress: undefined,
                  theme: "light",
                });
              }
            })
            .catch((err) => {});
        } catch (error) {
          console.log("voice", error);
        }
      }
    } catch (error) {
      console.log("SupervisorObserver", error);
    }
  };

  const agentActivityCount = async () => {
    const agentId = JSON.parse(localStorage.getItem("tokenAgent"));
    try {
      await axios
        .post(
          BaseUrl + "/dashboard/chatCount",
          {
            from_date: defaultValue,
            to_date: defaultValue,
            offset: 0,
            limit: 100,
            agent_id: agentId.agent_id,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            setTeamactivitydashboardcount(res.data.Data);
          } else {
            setTeamactivitydashboardcount([]);
          }
        });
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    agentActivityCount();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      agentActivityCount();
    }, 5000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const openOngoingInteractionApi = (agentID) => {
    console.log("openOngoingInteractionApi", agentID);
    let body = {
      agentId: agentID,
      offset: Interactionpage == 1 ? 0 : (Interactionpage - 1) * 5,
      limit: 5,
    };
    axios
      .post(BaseUrl + "/users/agentActiveChat", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        setOngoingInteractionList(res.data.data);
        setInteractionpagePagination(res.count);
      })

      .catch((error) => {
        setOngoingInteractionList([]);
      });
  };

  const openOngoingInteractionDialogBox = (value) => {
    openOngoingInteractionApi(value);
    setOngoingInteraction(true);
  };
  const OngoingInteractionDialogBoxclose = () => {
    setOngoingInteraction(false);
  };
  const InteractionhandleChange = (event, value) => {
    setInteractionpage(value);
  };
  useEffect(() => {
    openOngoingInteractionApi();
  }, [Interactionpage]);

  return (
    <>
      <div className="row">
        <div className="col-md-12 grid-margin stretch-card">
          <div
            className="card"
            style={{ height: "100vh", overflowY: "scroll" }}
          >
            <div className="card-body">
              <Stack direction={"row"} sx={{ display: "flex" }}>
                <Typography>Team Activity</Typography>
              </Stack>

              <div className="row mt-2">
                <div className="col-12">
                  <div className="table-responsive">
                    <table
                      id="example"
                      className="display expandable-table"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th className="dashboard-heading-table">
                            Agent Name
                          </th>
                          <th className="text-center dashboard-heading-table">
                            Status
                          </th>
                          <th className="text-center dashboard-heading-table">
                            Ongoing Interaction
                          </th>
                          <th className="text-center dashboard-heading-table">
                            Total Call
                          </th>
                          <th className="text-center dashboard-heading-table">
                            Total In/Out
                          </th>
                          <th className="text-center dashboard-heading-table">
                            Missed Call
                          </th>
                          <th className="text-center dashboard-heading-table">
                            Transferred
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {teamactivitydashboardcount.length > 0 ? (
                          teamactivitydashboardcount.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td
                                  className=""
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: "400",
                                  }}
                                >
                                  {item.agent_id == null ||
                                  item.agent_id == undefined ||
                                  item.agent_id == ""
                                    ? "--"
                                    : item.agent_id.username}
                                </td>

                                <td className="text-center">
                                  {item.agent_id ? (
                                    <Badge
                                      color={
                                        item.agent_id.agent_status_real ===
                                          "Available" ||
                                        item.agent_id.agent_status_real ===
                                          "Ready"
                                          ? "success"
                                          : item.agent_id.agent_status_real ===
                                            "Connected"
                                          ? "info"
                                          : "warning"
                                      }
                                      badgeContent={
                                        item.agent_id.agent_status_real
                                      }
                                      sx={{ width: 100, marginRight: "100px" }}
                                    ></Badge>
                                  ) : (
                                    "--"
                                  )}
                                </td>

                                <td
                                  className="text-center"
                                  id="interaction-chat"
                                >
                                  <Badge
                                    badgeContent={item.total_active}
                                    color="warning"
                                    sx={{ zIndex: "0" }}
                                  >
                                    <QuickreplyIcon
                                      color="primary"
                                      style={{
                                        cursor: "pointer",
                                      }}
                                    />
                                  </Badge>
                                </td>

                                <td className="text-center">
                                  <Badge
                                    badgeContent={item.presented_count}
                                    color="warning"
                                    sx={{ zIndex: "0" }}
                                  >
                                    <ForumIcon color="primary" />
                                  </Badge>
                                </td>
                                <td className="text-center">
                                  <Badge
                                    badgeContent={item.answered_count}
                                    color="warning"
                                    sx={{ zIndex: "0" }}
                                  >
                                    <PermPhoneMsgIcon color="primary" />
                                  </Badge>
                                </td>
                                <td className="text-center">
                                  <Badge
                                    badgeContent={item.abadoned_count}
                                    color="warning"
                                    sx={{ zIndex: "0" }}
                                  >
                                    <OutboundIcon color="primary" />
                                  </Badge>
                                </td>
                                <td className="text-center">
                                  <Badge
                                    badgeContent={item.total_transferred_out}
                                    color="warning"
                                    sx={{ zIndex: "0" }}
                                  >
                                    <SyncAltIcon color="primary" />
                                  </Badge>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <Stack>No Agent Found</Stack>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(mapStateToProps, {
  setsidebarVal,
})(ViewAllAgentDialogBox);
